export type VenueXPreviewKind =
  | "blog-index"
  | "blog-detail"
  | "homepage"
  | "content-page"
  | "services-archive"
  | "portfolio-archive"
  | "dynamic-archive"
  | "dynamic-detail";

type VenueXPreviewEnvelope = {
  kind: VenueXPreviewKind;
  path: string;
  payload: unknown;
};

let cachedPreview: VenueXPreviewEnvelope | null | undefined;

export function getVenueXPreview() {
  if (cachedPreview !== undefined) {
    return cachedPreview;
  }

  const source = document.querySelector<HTMLTemplateElement>("#venuex-preview-data");
  const serialized = source?.content.textContent?.trim();

  if (!serialized) {
    cachedPreview = null;
    return cachedPreview;
  }

  try {
    cachedPreview = JSON.parse(serialized) as VenueXPreviewEnvelope;
  } catch {
    cachedPreview = null;
  }

  return cachedPreview;
}

export function getVenueXPreviewPayload<T>(kind: VenueXPreviewKind): T | null {
  const preview = getVenueXPreview();
  return preview?.kind === kind ? (preview.payload as T) : null;
}
